<template lang="pug">
  .wrapper
    //- .buttons-filters(v-if="showInDashboard")
    //-   b-button(@click="filters.fase = null" variant="primary" :disabled="loading").filter-btn TOTAL
    //-   b-button(@click="filters.fase = NOKBO" variant="warning" :disabled="loading").filter-btn NOKBO
    //-   b-button(@click="filters.fase = STOP" variant="info" :disabled="loading").filter-btn STOP
    //-   b-button(@click="filters.fase = ALLOCATED" variant="success" :disabled="loading").filter-btn ALLOCATED
    .buttons-filters
      b-button.filter-btn(
        @click="toggleServicio(GARANTIA)"
        variant="outline-primary"
        :class="{ 'active': isGarantiaActive }"
        :disabled="loading || isSearching"
      ) Garantía

      b-button.filter-btn(
        @click="toggleServicio(PRESUPUESTO)"
        variant="outline-primary"
        :class="{ 'active': isPresupuestoActive }"
        :disabled="loading || isSearching"
      ) Presupuesto

      b-button.filter-btn(
        @click="toggleCliente(PERSONA)"
        variant="outline-primary"
        :class="{ 'active': isPersonaActive }"
        :disabled="loading || isSearching"
      ) Cliente persona

      b-button.filter-btn(
        @click="toggleCliente(EMPRESA)"
        variant="outline-primary"
        :class="{ 'active': isEmpresaActive }"
        :disabled="loading || isSearching"
      ) Cliente retail

      b-button.filter-btn(
        v-if="!showInDashboard"
        @click="toggleAlertColor(AMARILLA)"
        variant="outline-warning"
        :class="{ 'active': isAmarillaActive }"
        :disabled="loading"
      ) Alerta Amarilla

      b-button.filter-btn(
        v-if="!showInDashboard"
        @click="toggleAlertColor(ROJA)"
        variant="outline-danger"
        :class="{ 'active': isRojaActive }"
        :disabled="loading"
      ) Alerta Roja

      b-form-checkbox.mostrar-cerradas-check(
        v-if="!showInDashboard && searchingFilter"
        v-model="filters.mostrarCerradas"
        :disabled="loading"
      ) Mostrar cerrados

      b-button.filter-btn(
      @click="toggleOptions()"
      v-if="!hideOnSiteButton"
      variant="outline-info"
      :class="{ 'btn-disabled': !filters.on_site , 'active': filters.on_site }"
      :disabled="loading || isSearching"
      ) On Site

      b-button.clear-btn(
        v-if="hasAnyActiveFilter"
        @click="clearAllFilters"
        variant="link"
        :disabled="loading"
        size="sm"
      )
        b-icon(icon="x-circle" font-scale="0.85")
        |  Limpiar filtros

  </template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { mapState, mapWritableState } from 'pinia'
import { useDashboardStore } from '../../pinia/views/useDashboardStore'

export default {
  name: 'ButtonsFilters',

  props: {
    showInDashboard: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapWritableState(useDashboardStore, [
      'filters',
      'sortBy',
      'sortDesc',
      'tab',
    ]),
    ...mapState(useDashboardStore, ['loading']),
    ...mapGetters('OT', ['isSearching', 'searchingFilter']),
    hideOnSiteButton() {
      return this.$route.path === '/listar-ordenes'
    },

    // Computed properties for active states - read directly from URL for reliability
    isGarantiaActive() {
      const urlTipo = this.$route.query.tipoServicio

      return Number(urlTipo) === 1 || this.filters.tipoServicio === 1
    },
    isPresupuestoActive() {
      const urlTipo = this.$route.query.tipoServicio
      return Number(urlTipo) === 4 || this.filters.tipoServicio === 4
    },
    isPersonaActive() {
      return Number(this.$route.query.tipoCliente) === 1 || this.filters.tipoCliente === 1
    },
    isEmpresaActive() {
      return Number(this.$route.query.tipoCliente) === 2 || this.filters.tipoCliente === 2
    },
    isAmarillaActive() {
      const alertColors = this.$route.query.alertColor?.split(',') || []
      return alertColors.includes('yellow')
    },
    isRojaActive() {
      const alertColors = this.$route.query.alertColor?.split(',') || []
      return alertColors.includes('red')
    },

    GARANTIA: () => 1,
    PRESUPUESTO: () => 4,
    PERSONA: () => 1,
    EMPRESA: () => 2,
    ON_SITE: () => false,

    AMARILLA: () => 'yellow',
    ROJA: () => 'red',

    hasAnyActiveFilter() {
      const f = this.filters
      return (
        f.tipoServicio ||
        f.tipoCliente ||
        f.tecnico ||
        (f.alertColor && f.alertColor.length > 0) ||
        f.on_site !== null ||
        f.despacho ||
        this.sortBy
      )
    },
  },

  watch: {
    // Force reactivity on filters change - access store directly
    'filters.tipoServicio': {
      handler() {

      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations('OT', ['SET_IS_INITIAL_DATA']),
    toggleServicio(servicio) {
      this.SET_IS_INITIAL_DATA(false)
      this.filters.tipoServicio =
        this.filters.tipoServicio === servicio ? null : servicio
    },

    toggleCliente(cliente) {
      this.SET_IS_INITIAL_DATA(false)
      this.filters.tipoCliente =
        this.filters.tipoCliente === cliente ? null : cliente
    },
    toggleOptions() {
      this.filters.on_site = !this.filters.on_site
    },
    toggleAlertColor(color) {
      this.SET_IS_INITIAL_DATA(false)
      const i = this.filters.alertColor.indexOf(color)
      if (i === -1) {
        this.filters.alertColor = [...this.filters.alertColor, color]
      } else {
        this.filters.alertColor = this.filters.alertColor.filter(
          (c) => c !== color
        )
      }
    },
    cleanFilters() {
      Object.assign(this.filters, {
        tipoServicio: null,
        tipoCliente: null,
        fase: null,
        alertColor: [],
        on_site: false,
        tecnico: null,
        despacho: null,
        mostrarCerradas: true,
      })
      this.sortBy = null
      this.sortDesc = false
      this.tab = null
    },
    clearAllFilters() {
      this.SET_IS_INITIAL_DATA(false)
      Object.assign(this.filters, {
        tipoServicio: null,
        tipoCliente: null,
        fase: null,
        alertColor: [],
        on_site: null,
        tecnico: null,
        despacho: null,
      })
      this.sortBy = null
      this.sortDesc = false
      this.tab = null
      // Clear URL to just the path
      this.$router.replace({ query: {} }).catch(() => {})
    },
  },
  // toggleAlertColor(color) {
  //   const i = this.filters.alertColor.indexOf(color)
  //   if (i === -1) {
  //     this.filters.alertColor = [...this.filters.alertColor, color]
  //   } else {
  //     this.filters.alertColor = this.filters.alertColor.filter(
  //       (c) => c !== color
  //     )
  //   }
  // },
  // cleanFilters() {
  //   Object.assign(this.filters, {
  //     tipoServicio: null,
  //     tipoCliente: null,
  //     fase: null,
  //     alertColor: [],
  //   })
  // },
  mounted() {
    // Check if filters are already set from URL before cleaning

    // Only clean filters if we're not loading from URL (no existing filter values)
    const hasExistingFilters =
      this.filters.tipoServicio ||
      this.filters.tipoCliente ||
      this.filters.tecnico ||
      (this.filters.alertColor && this.filters.alertColor.length > 0) ||
      this.filters.on_site !== null ||
      this.filters.despacho

    if (!hasExistingFilters) {

      this.cleanFilters()
      if (this.showInDashboard) {
        this.filters.tipoServicio = this.GARANTIA
        this.filters.on_site = false
      }
    } else {

      // Force update to ensure computed properties re-evaluate
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.mostrar-cerradas-check {
  align-self: center;
  font-size: 13px;
  color: #74788d;
  white-space: nowrap;
}
.buttons-filters {
  display: flex;
  justify-content: start;
  gap: 10px;

  @include media-breakpoint-down(md) {
    justify-content: center;
    width: 100%;
  }
  @include media-breakpoint-down(sm) {
    flex-wrap: wrap;
  }
  .buttons-filters {
    display: flex;
    justify-content: start;
    gap: 10px;

    @include media-breakpoint-down(md) {
      justify-content: center;
      width: 100%;
    }
    @include media-breakpoint-down(sm) {
      flex-wrap: wrap;
    }
  }
  .filter-btn {
    border-radius: 5px;
    // width: 175px;
    width: 140px;
    height: 45px;
    line-height: 1;
    @include media-breakpoint-only(md) {
      flex-grow: 1;
      width: auto;
      min-width: 100px;
    }
    @include media-breakpoint-down(sm) {
      width: calc(50% - 10px);
    }
    &.disabled.active {
      background-color: #727cac;
      color: #fff;
    }
  }
  ::v-deep .btn-secondary,
  .btn-secondary:hover {
    color: #fff;
    font-weight: bold;
    background-color: #5b73e8;
    border-color: #5b73e8;
    opacity: 1;
  }
  ::v-deep .btn-warning,
  .btn-warning:hover {
    color: #202223;
    font-weight: bold;
    background-color: #f1b44c;
    border-color: #f1b44c;
    opacity: 0.8;
  }
  ::v-deep .btn-info,
  .btn-info:hover {
    color: #202223;
    font-weight: bold;
    background-color: #0096db;
    border-color: #0096db;
    opacity: 0.8;
  }
  ::v-deep .btn-success,
  .btn-success:hover {
    color: #202223;
    font-weight: bold;
    background-color: #34c38f;
    border-color: #34c38f;
    opacity: 0.9;
  }
}
@include media-breakpoint-down(sm) {
  .btn-disabled {
    background-color: white !important;
    color: #74788d !important;
  }
}
</style>
